export { RdProjectEligibilityModal as ProjectEligibilityModal } from './project-eligibility-modal.styled';
